import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import SubscribeForm from '@/components/feature/SubscribeForm';
import useSeo from '@/hooks/useSeo';
import { faqs, posts } from '@/mocks/posts';
import Hero from './components/Hero';
import Ticker from './components/Ticker';
import StatsStrip from './components/StatsStrip';
import CategoryStrip from './components/CategoryStrip';
import HotBoard from './components/HotBoard';
import CategoryBlock from './components/CategoryBlock';
import DeepFeature from './components/DeepFeature';
import FaqSection from './components/FaqSection';

const HOME_JSONLD = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '18爆料网',
    url: '/',
    description: '娱乐爆料资讯聚合站，每日更新明星八卦、网红翻车、素人投稿与深度追踪。',
    email: 'tips@18bolaodaily.example',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '18爆料网',
    inLanguage: 'zh-CN',
    url: '/',
    description: '18爆料网今日爆料实时更新，明星八卦、网红翻车、素人投稿一网打尽。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: { '@type': 'Answer', text: item.a },
    })),
  },
];

export default function Home() {
  useSeo({
    title: '18爆料网 | 18爆料网今日爆料 最新猛料合集每日追更',
    description:
      '18爆料网今日爆料实时更新，明星八卦、网红翻车、素人投稿一网打尽。想看18爆料网最新猛料，这里每天都有新鲜热乎的瓜，热门爆料、独家内幕、事件全貌一次看个够。',
    keywords: '18爆料网,18爆料网今日爆料,18爆料网最新猛料,18爆料网热门爆料,18爆料网今日更新',
    path: '/',
    jsonLd: HOME_JSONLD,
  });

  const featured = posts[0];
  const secondary = [posts[1], posts[3]];

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="w-full">
        <Ticker posts={posts} />
        <Hero featured={featured} secondary={secondary} />

        <div className="py-2">
          <StatsStrip />
        </div>

        <CategoryStrip />
        <HotBoard />
        <CategoryBlock slug="star" />
        <CategoryBlock slug="influencer" />
        <DeepFeature />
        <FaqSection />

        <section id="subscribe" className="w-full scroll-mt-20 px-4 py-12 md:px-8" aria-labelledby="subscribe-heading">
          <div className="grid grid-cols-1 items-start gap-8 rounded-lg bg-background-100 p-6 lg:grid-cols-[1fr_1.3fr] md:p-10">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                <i className="ri-send-plane-line" aria-hidden="true"></i>
                订阅与投稿
              </span>
              <h2 id="subscribe-heading" className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                每天三条，帮你把瓜吃明白
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                我们不做标题党式的堆砌，只挑当天信息最完整、证据最扎实的三条，整理好时间线再发给你。
              </p>
              <ul className="mt-5 space-y-3 text-sm text-foreground-700">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-600" aria-hidden="true"></i>
                  每日下午统一推送，不打扰
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-600" aria-hidden="true"></i>
                  线索匿名可选，隐私优先
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-600" aria-hidden="true"></i>
                  事件有反转会同步更新
                </li>
              </ul>
            </div>
            <SubscribeForm />
          </div>
        </section>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}